import { Button, Divider, IconButton } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import { DateRange, Room, School } from '@material-ui/icons';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import { getFormationById } from '@webapps/business';
import { Modal, useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarCompany from 'components/Avatar/AvatarCompany';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import AddEducation from './AddEducation';
import theme from './theme';

const {
  colors: { background, schoolNameColor },
} = theme;

const Education = ({ trainings = [], refetch }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const [addEducation, setAddEducation] = useState(false);
  const [editEducation, setEditEducation] = useState(false);
  const [idEdit, setIdEdit] = useState(null);

  const {
    data: formation,
    isLoading,
    refetch: fetchFormation,
  } = useQuery(getFormationById, {
    key: ['FormationProfilStudent', idEdit],
    variables: { id: idEdit },
  });

  const handleOpenAddEducation = () => {
    setAddEducation(true);
  };
  const handleCloseAddEducation = () => {
    setAddEducation(false);
  };

  const handleOpenEditEducation = () => {
    setEditEducation(true);
  };
  const handleCloseEditEducation = () => {
    setEditEducation(false);
    setIdEdit(null);
  };

  const openEdit = (id) => {
    setIdEdit(id);
    fetchFormation();
    handleOpenEditEducation();
  };

  const ProgressOrAnd = (value, startValue) => {
    if (new Date(value) > new Date()) {
      return '(en cours)';
    } else if (value === null) {
      return '(en cours)';
    } else if (new Date(startValue) > new Date()) {
      return '(à venir)';
    } else return '(terminé)';
  };

  const [isSeeMore, setIsSeeMore] = useState(false);
  return (
    <div className={classes.container}>
      <div className={classes.editContainer}>
        <div className={global.title}>
          <FormattedMessage id="student.profil.education.title" />
          {trainings.length ? ' (' + trainings.length + ')' : ''}
        </div>
        <div>
          <IconButton
            onClick={handleOpenAddEducation}
            size="small"
            style={{
              margin: 3,
              borderRadius: '20px',
              border: '1px solid #C0D9FF',
              backgroundColor: '#F3F7FF',
              width: '30px',
              display: 'flex',
              justifyContent: 'center',
              height: '30px',
              alignItems: 'center',
              cursor: 'pointer',
            }}
          >
            <AddIcon fontSize="small" style={{ color: '#5A6DA1' }} />
          </IconButton>
        </div>
      </div>
      {trainings?.length === 0 && (
        <div
          className={cx(css({
            textAlign: 'center',
            marginTop: spacing(2),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '190px',
          }), global.infoText)}
        >
          <FormattedMessage id="noElements" />
        </div>
      )}
      {trainings
        ?.slice(0, isSeeMore ? trainings.length : 2)
        .map(
          (
            {
              city,
              degree,
              endDate,
              id,
              label,
              school,
              schoolId,
              startDate,
              verified,
              degreeObtained,
            },
            index
          ) => (
            <>
              <div key={index} className={classes.educationContainer}>
                <div>
                  <div style={{ display: 'flex' }}>
                    <div className={classes.photo}>
                      {schoolId ? (
                        <AvatarCompany
                          height={70}
                          idCompany={schoolId}
                          name={school}
                          variant="rounded"
                          width={70}
                        />
                      ) : (
                        <Avatar className={classes.avatar} variant="rounded">
                          {school?.substr(0, 1)}
                        </Avatar>
                      )}
                    </div>
                    <div className={classes.educationDescription}>
                      <div className={classes.name}>
                        <div>
                          {' '}
                          {label}
                          <span style={{ marginLeft: spacing(1) }}>
                            {verified && <VerifiedIcon color="#1DA1F2" />}
                          </span>
                        </div>
                      </div>
                      <div className={cx(global.infoText, classes.nameSchool)}>{school}</div>
                      <div className={cx(global.infoText, classes.address)}>
                        <Room className={global.infoIcon} />
                        {city}
                      </div>
                      <div>
                        <div className={cx(global.infoText, classes.address)}>
                          <School className={global.infoIcon} />
                          {degree?.label} {ProgressOrAnd(endDate, startDate)}
                        </div>
                        <div className={cx(global.infoText, classes.address)}>
                          <DateRange className={global.infoIcon} />
                          <FormattedDate
                            day="numeric"
                            month="long"
                            value={startDate}
                            year="numeric"
                          />{' '}
                          {endDate ? (
                            <>
                              au{' '}
                              <FormattedDate
                                day="numeric"
                                month="long"
                                value={endDate}
                                year="numeric"
                              />
                            </>
                          ) : (
                            " - Aujourd'hui"
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {verified === false && (
                  <div className={css({ marginLeft: 'auto' })}>
                    <IconButton
                      onClick={() => openEdit(id)}
                      size="small"
                      style={{
                        margin: 3,
                        borderRadius: '20px',
                        border: '1px solid #C0D9FF',
                        backgroundColor: '#F3F7FF',
                        width: '30px',
                        display: 'flex',
                        justifyContent: 'center',
                        height: '30px',
                        alignItems: 'center',
                        cursor: 'pointer',
                      }}
                    >
                      <EditIcon
                        fontSize="inherit"
                        style={{ color: '#5A6DA1' }}
                      />
                    </IconButton>
                  </div>
                )}
              </div>
              {index !== trainings?.length - 1 && (
                <Divider className={css({ marginTop: spacing(1) })} />
              )}
            </>
          )
        )}
      <div
        style={{
          display: 'flex',
          marginTop: spacing(3),
          justifyContent: 'center',
        }}
      >
        {trainings?.length > 2 && (
          <Button
            onClick={() => setIsSeeMore(!isSeeMore)}
            className={css({ fontWeight: 600, width: '100%' })}
            variant="outlined"
          >
            {isSeeMore ? ' Voir moins' : 'Voir plus '}
          </Button>
        )}
      </div>
      <Modal
        onCancel={handleCloseAddEducation}
        open={addEducation}
        title={<FormattedMessage id="addEducation.title" />}
      >
        <AddEducation close={handleCloseAddEducation} refetch={refetch} />
      </Modal>
      <Modal
        onCancel={handleCloseEditEducation}
        open={editEducation}
        title={<FormattedMessage id="addEducation.titleEdit" />}
      >
        <AddEducation
          close={handleCloseEditEducation}
          idEdit={idEdit}
          initialData={formation}
          isLoadingEdit={isLoading}
          refetch={refetch}
        />
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    background,
    flex: '1 1 0px',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    padding: '20px',
    minHeight: 100,
    height: '100%',
    paddingBottom: spacing(2),
  },
  editContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  educationContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: spacing(2),
  },
  avatar: {
    height: 70,
    width: 70,
  },
  educationDescription: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: spacing(2),
  },
  nameSchool: {
    color: '#0060F9',
    display: 'flex',
    marginTop: spacing(0.5),
    alignItems: 'center',
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    marginTop: spacing(1),
  },
});

Education.propTypes = {
  trainings: PropTypes.array,
  refetch: PropTypes.func,
};

export default Education;
